import { useRefinementList } from 'react-instantsearch';
import { FormattedMessage } from 'react-intl';

import { LabelM } from '@sorare/core/src/atoms/typography';

type Props = {
  playerDisplayName: string;
};

export const Supply = ({ playerDisplayName }: Props) => {
  const { items } = useRefinementList({
    attribute: 'player.display_name',
  });

  if (!playerDisplayName) return null;

  const count =
    items.find(item => item.value === playerDisplayName)?.count || 0;
  return (
    <LabelM color={count < 4 ? 'var(--c-red-600)' : 'var(--c-neutral-600)'}>
      <FormattedMessage
        id="primaryBuy.modal.preview.supply"
        defaultMessage="{count, plural, one {# card} other {# cards}} available"
        values={{
          count,
        }}
      />
    </LabelM>
  );
};
